export default __webpack_public_path__ + "resources/icons/n342-abe8.webp";